import { Icon } from '@iconify/react/dist/iconify.js';
import { Box, Typography } from '@mui/material';
import React, { ReactNode } from 'react';



const MilestonesWrapper = ({ children, headerText, onDelete, leftContent, sx }) => {
  return (
    <Box
      sx={{
        padding: "1.5rem",
        borderRadius: "1rem",
        border: "1px solid #BEBEBE",
        mb: 2, // optional spacing between wrappers
        ...sx
      }}
    >
      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <Typography variant="h3">{headerText}</Typography>
        <Box sx={{ display: "flex", alignItems: "center", gap:2}}>
          {leftContent && leftContent}
          {onDelete && (
            <Box
              sx={{ display: "flex", alignItems: "center", gap: 1, cursor: "pointer" }}
              onClick={onDelete}
            >
              <Icon icon="material-symbols:delete-outline" width="24" height="24" color="#CB0505" />
              <Typography color="#CB0505" variant="body2">Remove</Typography>
            </Box>
          )}
        </Box>
      </Box>

      {/* Render children */}
      <Box mt={2}>{children}</Box>
    </Box>
  );
};

export default MilestonesWrapper;
